import { JOB_MODULE_PREFIX } from '../constants';
export const JOB_CANCEL_REASSIGN_JOB_TO_RESOURCE = `${JOB_MODULE_PREFIX}_CANCEL_REASSIGN_JOB_TO_RESOURCE`;
export const JOB_CANCEL_REASSIGN_JOB_TO_RESOURCE_SUCCESS = `${JOB_MODULE_PREFIX}_CANCEL_REASSIGN_JOB_TO_RESOURCE_SUCCESS`;
export const JOB_CANCEL_REASSIGN_JOB_TO_RESOURCE_FAILURE = `${JOB_MODULE_PREFIX}_CANCEL_REASSIGN_JOB_TO_RESOURCE_FAILURE`;
export const cancelReassignJobToResourceAction = (resourceCancelAssignmentPayload) => ({
    type: JOB_CANCEL_REASSIGN_JOB_TO_RESOURCE,
    payload: { resourceCancelAssignmentPayload }
});
export const cancelReassignJobToResourceSuccessAction = (payload) => ({
    type: JOB_CANCEL_REASSIGN_JOB_TO_RESOURCE_SUCCESS,
    payload: { payload }
});
export const cancelReassignJobToResourceFailureAction = (failureMessage) => ({
    type: JOB_CANCEL_REASSIGN_JOB_TO_RESOURCE_FAILURE,
    payload: { failureMessage }
});
//# sourceMappingURL=cancelReassignJobToResourceActions.js.map